<template>
  <div class="home-main">
    <div class="header">
      <img
        style="height:478px; width: 1170px"
        class="img-fluid home-img"
        src="img/banner-front.jpg"
        alt="home-img"
      />
    </div>
    <div style="flex-direction:column;" class="home-content flex-centered">
      <p>Página criada para você saber tudo sobre o Covid-19</p>
      <p></p>
      <p>Dicas para prevenção</p>
      <div style="margin-top: 0; justify-contend:flex-end; align-items: center;" class="dicas flex-centered">
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/1.svg" alt="icone-1" />
          <p style="margin: 0">Use máscaras</p>
        </div>
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/2.svg" alt="icone-2" />
          <p style="margin: 0">Lave bem as mãos</p>
        </div>
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/3.svg" alt="icone-3" />
          <p style="margin: 0">Ao tossir use a parte interna do braço</p>
        </div>
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/4.svg" alt="icone-4" />
          <p style="margin: 0">Evite levar as mãos ao rosto</p>
        </div>
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/5.svg" alt="icone-5" />
          <p style="margin: 0">Evite contato com pessoas infectadas</p>
        </div>
        <div style="flex-direction:column" class="dica flex-centered">
          <img src="img/6.svg" alt="icone-6" />
          <p style="margin: 0">Mantenha os ambientes limpos e ventilados</p>

        </div>
      </div>
      <p></p>
      <p></p>
      <p style="margin-top: 0; margin-bottom: 0;">Conteúdo especial Lefisc</p>
    <!--  <div style="margin-bottom: 0; margin-top: 0;align-items:flex-start; width:100%;padding:0 150px;" class="conteudos flex-centered">
        <div style="flex-direction:column" class="conteudo flex-centered">
          <div class="icons flex-centered">
            <i style="color:#D2FAE6;" class="fas fa-circle elipse"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-file-alt"></i>
          </div>
          <p>Matérias</p>

          <button @click="$router.push({ name: 'Menu', params: {select:'materias'} })" class="abrir-btn">Abrir</button>

        </div>
        <div style="flex-direction:column; width:100%;" class="conteudo flex-centered">
          <div class="icons flex-centered">
            <i style="color:#C1EBF6" class="fas fa-circle elipse"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-bookmark"></i>
          </div>
          <p>Plantões</p>
          <button @click="$router.push({ name: 'Menu', params: {select:'plantoes'} })" class="abrir-btn">Abrir</button>
        </div>
        <div style="flex-direction:column;" class="conteudo flex-centered">
          <div class="icons flex-centered">
            <i style="color:#D6D5FE" class="fas fa-circle elipse"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-question-circle"></i>
          </div>
          <p style="font-size: 25px;position: relative;top: -50px;">
            Perguntas
            <br />e Respostas
          </p>
          <button @click="$router.push({ name: 'Menu', params: {select:'perguntaserespostas'} })" style="position: relative;top: -31px;" class="abrir-btn">Abrir</button>
        </div>
      </div>
      <div style="margin-bottom: 50px; margin-top:0; align-items:flex-start; width:100%;padding:0 150px;" class="conteudos flex-centered">
        --><!--<div style="flex-direction:column" class="conteudo flex-centered">
          <div class="icons flex-centered">
            <i style="color:#FDDBCD;" class="fas fa-circle elipse"></i>
            <i style="position:absolute; font-size: 30px;" class="far fa-file-video"></i>
          </div>
          <p>Vídeos</p>
          <button @click="$router.push({ name: 'Menu', params: {select:'videos'} })" class="abrir-btn">Abrir</button>
        </div>-->
        <div style="display: flex;
    justify-content: space-evenly;
    width: 100%;margin-bottom:30px;">
          <div style="flex-direction:column;" class="conteudo flex-centered">
            <div class="icons flex-centered">
              <i style="color:#FDF48E" class="fas fa-circle elipse"></i>
              <i style="position:absolute; font-size: 30px;" class="fas fa-book"></i>
            </div>
            <p>Legislações</p>
            <button @click="$router.push({ name: 'Menu', params: {select:'legislacoes'} })" class="abrir-btn">Abrir</button>
          </div>
          <div style="flex-direction:column;" class="conteudo flex-centered">
            <div class="icons flex-centered">
              <i style="color:#FED5EF" class="fas fa-circle elipse"></i>
              <i style="position:absolute; font-size: 30px;" class="fas fa-link"></i>
            </div>
            <p style="font-size: 30px;">
              Links
            </p>
            <button @click="$router.push({ name: 'Menu', params: {select:'links'} })" class="abrir-btn">Abrir</button>
       
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  methods: {},
  computed: {},
  watch: {},
  data() {
    return {
      geral: false,
      domestico: false
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
  },
  mounted() {
    this.$modal.show("welcome");
  }
};
</script>

<style>
* {
  font-family: "Segoe UI";
}

.flex-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 0 20px 0;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-img {
  z-index: 1;
  position: relative;
  object-fit: cover;
}

.home-title {
  position: relative;
  font-size: 50px;
  top: 305px;
  left: 510px;
  z-index: 2;
  color: #ffffff;
}

.home-content {
  background: white;
  position: relative;
  top: -100px;
  align-self: center;
  z-index: 3;
  border-radius: 10px;
  margin: 20px 90px 0 90px;
}

.home-content p {
  margin-top: 50px;
  color: #383838;
  font-size: 30px;
  font-weight: 700;
}

.dica {
  margin: 30px !important;
}

.dica p {
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}

.conteudo {
  margin: 0 75px;
  margin-top: 0 !important;
}

.conteudo p {
  position: relative;
  top: -30px;
  color: #383838;
  font-style: italic;
  text-align: center;
  width:100%;
  line-height: 30px;
  font-weight: 500;
}

.elipse {
  font-size: 100px;
}

.abrir-btn {
  width: 141px;
  height: 40px;
  background: #444e67;
  border-radius: 5px;
  color: #ffffff;
  font-style: italic;
  font-weight: lighter;
  font-size: 20px;
}


</style>